<template>
  <div class="mb-content">
    <Header></Header>
    <div class="list_box">
      <!-- 有数据时渲染列表 -->
      <template v-if="listData.length > 0">
        <div
          v-for="(value, key) in listData"
          :key="key"
          class="box pb10 mb15"
          @click="detail(value.vid, value.mid)"
        >
          <img class="integral-mall-goods" mode="aspectFill" :src="value.img" />
          <div class="mt8 plr10 ft14 ftw400 text-center text-over cl-main">
            {{ value.vname }}
          </div>
        </div>
      </template>
      <!-- 暂无数据提示 -->
      <div v-else class="empty-tip">{{$t("favorite.empty")}}</div>
    </div>
    <div style="width: 100%; height: 15px"></div>
  </div>
</template>

<script>
import Header from "@/components/module/header.vue";
import { favoriteList } from "@/apis/user";

export default {
  name: "FavoriteList",
  components: {
    Header,
  },
  data() {
    return {
      listData: [],
      last_id: 0,
      reload: true,
      pageSize: 10,
    };
  },
  mounted() {
    this.checkLoginAndLoad();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkLoginAndLoad() {
      const userInfo = this.$getUserInfo();
      if (!userInfo || !userInfo.id) {
        this.$router.push("/login");
        return;
      }
      this.getList();
    },

    getList() {
      const userInfo = this.$getUserInfo();
      if (!userInfo || !userInfo.id) {
        this.listData = [];
        return;
      }

      const limit = this.pageSize;
      const offset = this.last_id;

      const params = {
        limit,
        offset,
        uid: userInfo.id,
      };

      favoriteList(params)
        .then((res) => {
          const record = res.record
          if (this.reload) {
            this.listData = record;
            this.reload = false;
          } else {
            this.listData = this.listData.concat(record);
          }

          if (record.length === limit) {
            this.last_id += 1;
          }
        })
        .catch((err) => {
          console.error("获取收藏列表失败", err);
          if (this.reload) {
            this.listData = [];
            this.reload = false;
          }
        });
    },

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollTop + windowHeight >= documentHeight - 100) {
        if (this.listData.length > 0 && this.last_id > 0) {
          this.getList();
        }
      }
    },

    detail(vid, mid) {
      let fxpid = 1;
      const userInfo = this.$getUserInfo();
      if (userInfo && userInfo.id) {
        fxpid = userInfo.id;
      }
      if (!mid) mid = 0;
      this.$router.push({
        path: "/video/details/details",
        query: { vid: vid, mid: mid, fxpid: fxpid },
      });
    },
  },
};
</script>

<style scoped>
/* 基础布局 */
.mb-content {
  width: 100%;
  max-width: 450px;
  min-height: 100vh;
  margin: 0 auto;
  background: #f5f5f7;
  color: #1d1d1f;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif;
}

.list_box {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 10px;
  padding: 14px 12px 20px;
}

.box {
  min-width: 0;
  width: auto;
  margin-right: 0;
  border-radius: 0;
  margin-bottom: 0;
  cursor: pointer;
  background: transparent;
  box-shadow: none;
  transition: transform 0.12s ease;
}

.box:nth-child(3n) {
  margin-right: 0;
}

.box:active {
  transform: scale(0.98);
}

.integral-mall-goods {
  width: 100%;
  height: clamp(132px, 40vw, 178px);
  aspect-ratio: 3 / 4;
  display: block;
  background: #e5e5ea;
  border-radius: 14px;
  object-fit: cover;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.07);
}

.mt8 {
  margin-top: 8px;
}
.plr10 {
  padding-left: 2px;
  padding-right: 2px;
}
.ft14 {
  font-size: 12px;
}
.ftw400 {
  font-weight: 600;
}
.text-center {
  text-align: left;
}
.text-over {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 1.35;
  min-height: 2.7em;
  word-break: break-word;
}
.cl-main {
  color: #1d1d1f;
}

.pb10 {
  padding-bottom: 0;
}
.mb15 {
  margin-bottom: 0;
}

/* 暂无数据提示样式 */
.empty-tip {
  width: 100%;
  grid-column: 1 / -1;
  text-align: center;
  padding: 64px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #8e8e93;
}
</style>
